import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { ConfigServerService, CustomHttp, BaseReportService } from '../../../core';
import { TituloReceberFilter } from '../filter/titulo-receber-filter';


@Injectable({
    providedIn: 'root'
})
export class TituloReceberReportHttpService  {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp,
                private baseReportService: BaseReportService) {
        this.pathApi = `${configServerService.getPathApiPrint()}/tituloreceber`;
    }

    /** Realiza a impressão do relatório de listagem dos títulos a receber */
    printListagem(filter: TituloReceberFilter, orderBy: number, orderByDir: string): Promise<any> {
        return new Promise<void>((resolve, reject) => {
            // Params
            let params = new HttpParams()
                                .append('orderBy', orderBy.toString())
                                .append('orderByDir', orderByDir ? orderByDir : '');
            // Filter params
            if (filter) {
                params = filter.createParams(params);
            }

            this.customHttp.post<Blob>(`${this.pathApi}/listagem`, null, {params, responseType: 'blob'})
                .subscribe(
                    pdf => {
                        this.baseReportService.open(pdf);
                        resolve();
                    },
                    error => {
                        this.baseReportService.openError(error);
                        reject(error);
                    }
                )
        });
    }
}
